export default __webpack_public_path__ + "static/media/cake-3.e0972301.jpeg";